module.exports = __webpack_public_path__ + "static/media/infotip.d67decc3.svg";